import React, { useState, useEffect } from "react";
import styles from "./EditUser.module.scss";
import {useTypedSelector} from "../../../hook/useTypedSelector";
import {useActions} from "../../../hook/useActions";
import {useTranslation} from "react-i18next";

export default function EditUser() {
    const {allUsers, allRoles} = useTypedSelector((store) => store.user);
    const {GetAllUsersAsync, GetAllRolesAsync, EditUserAsync, UpdateRolesAsync} = useActions();
    const {t} = useTranslation();

    const [form, setForm] = useState<any>(null);

    const [roles, setRoles] = useState<string[]>([]);
    const [selectedRoles, setSelectedRoles] = useState<string[]>([]);

    useEffect(() => {
        if(allRoles && allUsers) return;
        GetAllRolesAsync();
        GetAllUsersAsync();
    }, []);

    useEffect(() => {
        if(!allUsers) return;

        const user = allUsers.find((u: any) => u.id === new URLSearchParams(window.location.search).get("id"));

        setForm({
            id: user?.id || "",
            fullName: user?.fullName || "",
            recomendatorNumber: user?.recomendatorNumber || "",
            country: user?.country || "",
            city: user?.city || "",
            email: user?.email || "",
            phoneNumber: user?.phoneNumber || "",
            password: ""
        });
        setSelectedRoles(user?.roles || []);
    }, [allUsers]);

    useEffect(() => {
        if(!allRoles) return;
        setRoles(allRoles);
    }, [allRoles]);

    const handleChange = (e: any) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmitUser = (e: any) => {
        e.preventDefault();
        EditUserAsync(form);
    };

    const handleRoleChange = (role: any) => {
        setSelectedRoles((prev) =>
            prev.includes(role) ? prev.filter((r) => r !== role) : [...prev, role]
        );
    };

    const handleSubmitRoles = (e: any) => {
        e.preventDefault();
        UpdateRolesAsync(form.id, selectedRoles);
    };

    if (!form || roles.length === 0) {
        return <div>Loading...</div>;
    }

    return (
        <div className={styles.container}>
            <div className={styles.horizontalForms}>
                {/* User Info Form */}
                <div className={styles.section + " " + styles.userInfo}>
                    <h3>Edit User Info</h3>
                    <form onSubmit={handleSubmitUser}>
                        <div className={styles.formGroup}>
                            <label className={styles.label}>Full Name *</label>
                            <input
                                className={styles.input}
                                type="text"
                                name="fullName"
                                value={form.fullName}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <label className={styles.label}>Recomendator Number *</label>
                            <input
                                className={styles.input}
                                type="text"
                                name="recomendatorNumber"
                                value={form.recomendatorNumber}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <label className={styles.label}>Country *</label>
                            <input
                                className={styles.input}
                                type="text"
                                name="country"
                                value={form.country}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <label className={styles.label}>City *</label>
                            <input
                                className={styles.input}
                                type="text"
                                name="city"
                                value={form.city}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <label className={styles.label}>Email *</label>
                            <input
                                className={styles.input}
                                type="email"
                                name="email"
                                value={form.email}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <label className={styles.label}>Phone Number *</label>
                            <input
                                className={styles.input}
                                type="text"
                                name="phoneNumber"
                                value={form.phoneNumber}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <label className={styles.label}>Password (leave empty if unchanged)</label>
                            <input
                                className={styles.input}
                                type="password"
                                name="password"
                                value={form.password}
                                onChange={handleChange}
                            />
                        </div>

                        <button type="submit" className={styles.button}>Save User Info</button>
                    </form>
                </div>

                {/* Roles Form */}
                <div className={styles.section}>
                    <h3>Edit Roles</h3>
                    <form onSubmit={handleSubmitRoles}>
                        {roles.map((role) => (
                            <div key={role} className={styles.checkbox}>
                                <input
                                    type="checkbox"
                                    id={role}
                                    checked={selectedRoles.includes(role)}
                                    onChange={() => handleRoleChange(role)}
                                />
                                <label htmlFor={role}>{t("Roles." + role)}</label>
                            </div>
                        ))}
                        <button type="submit" className={styles.button}>Save Roles</button>
                    </form>
                </div>
            </div>
        </div>
    );
}
